export default {
    LABEL_TOPICS     : 'Übersicht',
    LABEL_SUBTOPICS  : 'Bereiche',
    LABEL_LISTVIEW   : 'Artikelübersicht',
    LABEL_DETAILVIEW : 'Artikel',
    LABEL_MESSAGES   : 'Nachrichten',
    LABEL_WELCOME    : 'Willkommen',
    LABEL_IMPRESSUM  : 'Impressum',
    LABEL_STOB       : 'AGB',
    LABEL_PRIVACY    : 'Datenschutz',
    LABEL_REVOCATION : 'Widerruf',
    LABEL_LOGIN      : 'Login',
    LABEL_SUBSCRIBE  : 'Abonnieren',
    LABEL_SETTINGS   : 'Einstellungen',
    LABEL_ERROR      : 'Fehler',
    LABEL_FILTER     : 'Themen',
    LABEL_FILTERBTN  : 'Thema:',
    LABEL_ALLTOPICS  : 'Alle Bereiche'
}